/* eslint-disable import/no-anonymous-default-export */
export default (singleReceipt = [], action) => {
  switch (action.type) {
    case "SINGLE_LOCATION_RECEIPT":
      return action.payload;

    default:
      return singleReceipt;
  }
};
